import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Notification.css";

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";


const Notifications = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/notification`);
        console.log(res.data);

        setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  if (loading) return <div className="notif-loading">Loading...</div>;

  return (
    <div className="notifications-container">
      <h2>Notifications</h2>

      {/* 🔴 Inactive Resources */}
      <Link to="/user?filter=inactive" className="notification-card danger">
        <div className="notif-title">Inactive Resources</div>
        <div className="notif-count">{data?.inactiveResources || 0}</div>
        <div className="notif-desc">
          Resources whose last working day is before today
        </div>
      </Link>
      {/* ⚫ Last Working Day = Yesterday */}
      <Link
        to="/user?filter=lastWorkingTommorow"
        className="notification-card dark"
      >
        <div className="notif-title">Last Working Day (Yesterday)</div>
        <div className="notif-count">{data?.lastWorkingTommorow ?? 0}</div>
        <div className="notif-desc">
          Resources whose last working day was yesterday
        </div>
      </Link>

      {/* 🟡 Next 7 Days */}
      <Link
        to="/user?filter=lastworking7"
        className="notification-card warning"
      >
        <div className="notif-title">Last Working Day in Next 7 Days</div>
        <div className="notif-count">{data?.lastWorkingNext7Days ?? 0}</div>
        <div className="notif-desc">
          Resources exiting within the next 7 days
        </div>
      </Link>

      {/* 🟠 Last Working Day in Next 30 Days */}
      <Link
        to="/user?filter=lastworking30"
        className="notification-card warning"
      >
        <div className="notif-title">Last Working Day in Next 30 Days</div>
        <div className="notif-count">{data?.lastWorkingNext30Days || 0}</div>
        <div className="notif-desc">
          Resources exiting within the next 30 days
        </div>
      </Link>
    </div>
  );
};

export default Notifications;
